module.exports = __webpack_public_path__ + "fa-solid-900.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.eot
// module id = 4
// module chunks = 0